<template>
  <div class="text-center">
    <h1 class="margin-bottom-s">
      {{ headerText }}
    </h1>
    <p>Thank you for submitting a review!</p>
    <p>Your review is being moderated and may take up to a few days to appear.</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { usePageData } from '~/composables/usePageData';
import useWriteReview from '~/modules/reviews/composables/useWriteReview';

const { user } = usePageData();
const { getLastReviewUsername } = useWriteReview();
const userName = computed(() => getLastReviewUsername() || user.userName);
const headerText = computed(() => `Thanks${userName.value ? `, ${userName.value}` : ''}!`);
</script>
